/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense } from 'react';
import { CuratorSocialFeedAdapter } from 'PlugAndPlay/_data-layer/js/Adapters/SocialFeedAdapters/CuratorSocialFeedAdapter/CuratorSocialFeedAdapter';

// Lazy load the main SocialFeed 'app'
const SocialFeed = React.lazy(() =>
    import(/* webpackChunkName: "SocialFeed" */ './socialFeed')
);

const appWrapper = document.querySelectorAll('[data-component="social-feed"]');
// Don't run on a non calendar page
if (appWrapper.length > 0) {
    // Only load ReactDOM from if its needed as its pretty large
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom').then((ReactDOM) => {
        appWrapper.forEach((wrapper) => {
            let socialFeedAdapter;
            const { dataset } = wrapper;
            const appConfiguration = JSON.parse(dataset.appConfiguration);

            if (appConfiguration.datasource === 'curator') {
                socialFeedAdapter = new CuratorSocialFeedAdapter({
                    curatorUrl: appConfiguration.datasourceUrl,
                    apiKey: appConfiguration.datasourceApiKey,
                    feedId: appConfiguration.curatorFeed,
                });
            }

            ReactDOM.render(
                <Suspense
                    fallback={
                        <div className="calendar__loading">Loading...</div>
                    }
                >
                    <SocialFeed
                        {...appConfiguration}
                        socialFeedAdapter={socialFeedAdapter}
                    />
                </Suspense>,
                wrapper
            );
        });
    });
}
